import { useAuth } from 'react-oidc-context';
import axios from 'axios';
import { useMemo } from 'react';

export const useAuthenticatedAxios = () => {
  const auth = useAuth();

  return useMemo(() => {
    console.log('Creating axios instance with token:', auth.user?.access_token);
    return axios.create({
      baseURL: process.env.REACT_APP_BACKEND_URL || 'https://backend.thefrenchjourney.net',
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`
    },
    withCredentials: true
    });
  }, [auth.user?.access_token]); // Only recreate when token changes
};